(function ($) {
    var KEY = {
        BACKSPACE: 8,
        DELETE: 46,
        TAB: 9,
        RETURN: 13,
        ESC: 27,
        COMMA: 188,
        SPACE: 32,
        PAGEUP: 33,
        PAGEDOWN: 34,
        END: 35,
        HOME: 36,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    }; // Keys "enum"

    var $body = $(document.body);
    var $container = $body;
    var $view;
    var $form;
    var _titleValidation = false;
    var _addressValidation = false;
    var _tagValidation = false;
    var _brunchBookChecked = false;
    var _tagValidation_add;
    var $addressInput;
    var $addressBox;
    var $addressDeny;
    var $titleInput;
    var $titleBox;
    var $titleDeny;
    var $tagInput;
    var $tagList;
    var $tagBox;
    var $tagDeny;
    var $allowJoin;
    var $allowBrunchBook;
    var $brunchBookCategory;
    var $joinCheck;
    var $joinCheckIco;
    var $brunchBookCheck;
    var $brunchBookCheckIco;
    var $brunchBookCheckHelpLink;
    var _failHandler;
    var _successHandler;
    var _originalMagazine;
    var _tagList = [];
    var _isBrunchBookClosed = false;
    var _bookEvent = null;

    var _release = function () { // 특정 셀렉터 기반이라 off 가 필수..
        if (!$form) {
            return;
        }

        $form.off('submit');
        $form.off('reset');
        $body.off('click');
        $titleInput.off('blur');
        $titleInput.off('keyup');
        $addressInput.off('blur');
        $addressInput.off('keyup');
        $tagInput.off('keydown');
        $joinCheck.off('click');
        $brunchBookCheck.off('click');
        $brunchBookCheckHelpLink.off('click');
        $titleBox.off('click');
    };

    var _init = function (options) {
        _release();
        options = options || {};
        $container = options.container || $container;
        _successHandler = options.successHandler || function () {};
        _failHandler = options.failHandler || function () {};
        _originalMagazine = options.magazine;
        _isBrunchBookClosed = options.isBrunchBookClosed;
        _bookEvent = options.bookEvent;

        if (_bookEvent && _bookEvent.template && _bookEvent.template.bookCategory) {
            _bookEvent['bookCategory'] = $.parseJSON(_bookEvent.template.bookCategory);
        }

        $container.find('.magazine_layer.regist_join').remove();
        $view = $(B.Util.getTemplate('magazine-form.hbs', {
            serviceDomain: B.Config.serviceDomain,
            magazine: _originalMagazine,
            isBrunchBookClosed: _isBrunchBookClosed,
            bookEvent: _bookEvent
        }));
        $container.append($view);

        $form = $view.find('form');

        $addressInput = $form.find('#inpUrl');
        $addressBox = $form.find('.box_url');
        $addressDeny = $form.find('.box_url .txt_deny');

        $titleInput = $form.find('#inpName');
        $titleBox = $form.find('.box_subject');
        $titleDeny = $form.find('.box_subject .txt_deny');

        $tagInput = $form.find('#inpTag');
        $tagList = $form.find('.tag_list');
        $tagBox = $form.find('.create_tag');
        $tagDeny = $form.find('.create_tag .txt_deny');

        $allowJoin = $form.find('#allowJoin');
        $allowBrunchBook = $form.find('#allowBrunchBook');
        $brunchBookCategory = $form.find('#brunchBookCategory');

        $joinCheck = $form.find('.choice_comm input');
        $joinCheckIco = $form.find('.choice_comm label span.ico_brunch');

        $brunchBookCheck = $form.find('.choice_book input');
        $brunchBookCheckIco = $form.find('.choice_book label span.ico_brunch');
        $brunchBookCheckHelpLink =  $('.book_help_link');

        _initForm(options.magazine);

        $form.on('submit', onFormSubmit);
        $form.on('reset', onFormReset);
        $body.on('click', onBodyClick);
        $titleInput.on('blur', onTitleBlur);
        $titleInput.on('keyup', onTitleKeyup);
        $addressInput.on('blur', onMagazineAddressBlur);
        $addressInput.on('keyup', onMagazineAddressKeyup);
        $tagInput.on('keydown', onTagInputKeydown);

        $joinCheck.on('click', onJoinCheckClick);
        $brunchBookCheck.on('click', onBrunchBookCheckClick);
        $brunchBookCheckHelpLink.on('click', function (e) {
            e.preventDefault();
            window.open($(this).attr('href'));
        });

        $titleBox.on('click', onTitleBoxClick);

    };

    var _initForm = function (magazine) {
        _addressDenyMessage();
        _titleDenyMessage();
        _tagDenyMessage();

        _titleValidation = false;
        _addressValidation = false;
        _tagValidation = false;

        $titleInput.val('');
        $addressInput.val('');
        $tagInput.val('');
        _tagList = [];
        $tagList.empty();
        $allowJoin.val('1');

        $allowBrunchBook.val(0);
        _adjustAllowBrunchBook();

        if (magazine) {
            _originalMagazine = magazine;
            $titleInput.val(magazine.title);
            $('.box_register.box_url.edit_url .txt_default').text('brunch.co.kr/magazine/' + magazine.magazineAddress);
            $allowJoin.val(magazine.allowJoin);
            for (var i = 0; i < magazine.tagList.length; i++) {
                if (magazine.tagList[i] == '브런치북') {
                    $allowBrunchBook.val(1);
                }

                _addTag(magazine.tagList[i], true);
            }

            if (magazine.bookCategory) {
                choiceBookCategory(magazine.bookCategory);
            }
        } else if (!_isBrunchBookClosed) {
            $allowBrunchBook.val(1);
        }

        _adjustTagInput();
        _adjustPreventAllowJoin(magazine);
        _adjustAllowJoin();
        _adjustAllowBrunchBook();
        $titleInput.focus();
    };

    var _show = function () {
        $view.show();
    };

    var _hide = function () {
        $view.hide();
    };

    var _postMagazine = function (address, title, tags, allowJoin) {
        var url = B.Config.apiUrl + '/v1/magazine';

        if (_originalMagazine) {
            url += '/' + _originalMagazine.magazineNo;
        }

        var bookCategory = 0;

        if ($brunchBookCategory.val()) {
            bookCategory = $brunchBookCategory.val();
        }

        B.Util.ajax({
            url: url,
            method: 'POST',
            data: {
                magazineAddress: address,
                magazineTitle: title,
                magazineTags: tags,
                magazineAllowJoin: allowJoin,
                brunchBookChecked: _brunchBookChecked,
                brunchBookCategory: bookCategory
            },
            success: function (r) {
                _successHandler(r.data.magazine, r.data.createMore, r.data.totalCount, r.data.extras);
            },
            error: function (r) {
                B.Util.alert(r.responseJSON.desc);
                _failHandler();
            }
        });
    };

    var _addTag = function (tag, ignoreDenyMessage) {
        var book_k = new RegExp('브런치북');
        var book_e = new RegExp('brunchbook');
        var weekly = new RegExp('위클리매거진');

        if (book_k.test(tag) || book_e.test(tag.toLowerCase()) || weekly.test(tag)) {
            if (!ignoreDenyMessage) {
                _tagDenyMessage('사용할 수 없는 태그가 있습니다. 다른 태그를 입력해주세요.');
                _tagValidation_add = false;
            }

            return;
        }

        if (_tagList.length >= 3) {
            if (!ignoreDenyMessage) {
                _tagDenyMessage('직접 입력하는 태그는 1개 이상 3개 이하로 입력해 주세요.');
                _tagValidation_add = false;
            }

            return;
        }

        if (tag.search(/^[a-zA-Z0-9ㄱ-힣]+$/) < 0) {
            if (!ignoreDenyMessage) {
                _tagDenyMessage('태그는 한글, 영문, 숫자로 만들어 주세요.');
                _tagValidation_add = false;
            }

            return;
        }

        if (tag.search(/[\u4E00-\u9FFF]/) > -1) {
            if (!ignoreDenyMessage) {
                _tagDenyMessage('태그는 한글, 영문, 숫자로 만들어 주세요.');
                _tagValidation_add = false;
            }

            return;
        }

        if ($.inArray(tag, _tagList) >= 0) {
            if (!ignoreDenyMessage) {
                _tagDenyMessage('이미 입력하신 태그입니다.');
                _tagValidation_add = false;
            }

            return;
        }

        _tagDenyMessage();

        _tagList.push(tag);
        $tagList.append($(B.Util.getTemplate('magazine-form-tag.hbs', { name: tag })));
        $tagInput.val('');
        _adjustTagInput();
        _tagValidation_add = true;
    };

    var _removeTag = function ($target) {
        var tag = $target.data('name');

        $target.parent().remove();
        _tagList.splice(_tagList.indexOf(tag), 1);
        _adjustTagInput();
    };

    var _adjustTagInput = function () {
        if (_tagList.length >= 3) {
            $tagBox.addClass('hide_input');
            //$tagDeny.css('display','none');
        } else {
            $tagBox.removeClass('hide_input');
            $tagInput.focus();
        }
    };

    var _adjustPreventAllowJoin = function (magazine) {
        if (magazine) {
            if (magazine.preventAllowJoin) {
                $('.allow_join_wrap').css('visibility', 'hidden');
            } else {
                $('.allow_join_wrap').css('visibility', 'visible');
            }
        }
    };

    var _adjustAllowJoin = function () {
        if ($allowJoin.val() == '1') {
            $joinCheckIco.addClass('ico_choiced');
            $('.choice_comm').addClass('on');
        } else {
            $joinCheckIco.removeClass('ico_choiced');
            $('.choice_comm').removeClass('on');
        }
    };

    var _adjustAllowBrunchBook = function () {
        if ($allowBrunchBook.val() == '1') {
            return;
            // var tag = '브런치북';
            // $tagList.prepend($(B.Util.getTemplate("magazine-form-tag.hbs", {name:tag})).css("color", "#00c3bd"));
            // $brunchBookCheckIco.addClass("ico_choiced");
            // var _target = $('[data-name="브런치북"]');
            // _target.css("display", "none");
            // _brunchBookChecked = true;
            // $('.choice_book').addClass("on");
            // $(".opt_field[data-action=openBookCategory]").removeClass("dimmed");
        } else {
            $brunchBookCheckIco.removeClass('ico_choiced');
            var _target = $('[data-name="브런치북"]');
            _target.parent().remove();
            _brunchBookChecked = false;
            $('.choice_book').removeClass('on');
            $brunchBookCategory.val(0);
            $('.opt_field_label').html('분야선택');
            $('.opt_field[data-action=openBookCategory]').addClass('dimmed');
        }
    };

    var _tagDenyMessage = function (msg) {
        if (msg) {
            $tagBox.addClass('deny_on');
        } else {
            $tagBox.removeClass('deny_on');
        }

        $tagDeny.text(msg);
    };

    var _titleDenyMessage = function (msg) {
        if (msg) {
            $titleBox.addClass('deny_on');
        } else {
            $titleBox.removeClass('deny_on');
        }

        $titleDeny.text(msg);
    };

    var _addressDenyMessage = function (msg) {
        if (msg) {
            $addressBox.addClass('deny_on');
        } else {
            $addressBox.removeClass('deny_on');
        }

        $addressDeny.text(msg);
    };


    // validation
    var validateTitle = function (strict) {
        _titleValidation = false;
        var val = B.Util.trim($titleInput.val());

        if (val.length == 0) {
            if (strict) {
                $titleBox.find('.placeholder').css('display', 'block');
                _titleDenyMessage('제목을 입력해 주세요.');
            } else {
                _titleDenyMessage();
            }

            return;
        }

        if (val.search(/\s{2,}/) >= 0) {
            _titleDenyMessage('띄어쓰기는 연속으로 사용할 수 없습니다.');
            return;
        }

        if (val.search(/[一-龥]/) > -1 || val.search(/^[a-zA-Z0-9ㄱ-힣\s]+$/) < 0) {
            _titleDenyMessage('한글, 영문, 숫자, 띄어쓰기만 사용할 수 있습니다.');
            return;
        }


        _titleDenyMessage();
        _titleValidation = true;
    };

    var validateAddress = function (strict) {
        var val = $addressInput.val().toLowerCase();
        _addressValidation = false;

        if (val.length == 0) {
            if (strict) {
                _addressDenyMessage('매거진 주소를 입력해 주세요.');
            } else {
                _addressDenyMessage();
            }

            return;
        }

        if (val.length < 4) {
            if (strict) {
                _addressDenyMessage('주소는 4자 이상으로 입력해 주세요.');
            }

            return;
        }

        if (val.search(/^[a-zA-Z0-9\-]+$/) < 0) {
            _addressDenyMessage('주소는 영문, 숫자, -으로 만들어 주세요.');
            return;
        }

        if (val.search(/--/) >= 0) {
            _addressDenyMessage('주소에 -은 연속으로 사용할 수 없습니다.');
            return;
        }

        if (val.search(/^-/) >= 0 || val.search(/-$/) >= 0) {
            _addressDenyMessage('주소 가장 처음과 끝에는 -을 사용할 수 없습니다.');
            return;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/magazine/checkAddress/' + val,
            method: 'GET',
            data: {},
            success: function (data) {
                if (data.code == 200) {
                    _addressDenyMessage();
                    _addressValidation = true;
                }
            },
            error: function (data) {
                if (data.code == 409) {
                    _addressDenyMessage('이미 사용 중인 매거진 주소입니다.');
                } else {
                    _addressDenyMessage('사용할 수 없는 주소입니다.');
                }
            }
        });
    };

    var validateTagList = function () {
        var val = $tagInput.val();

        if (val.length > 0) {
            _addTag(val, false);
        }

        if (_tagValidation_add == false) {
            return;
        }

        if (_tagList.length < 1) {
            _tagDenyMessage('직접 입력하는 태그는 1개 이상 3개 이하로 입력해 주세요.');
            _tagValidation = false;
            return;
        }

        if (_tagValidation_add != false || typeof _tagValidation_add == 'undefined') {
            _tagValidation = true;
        }
    };

    var validateEvent = function () {
        if ($allowBrunchBook.val() == 1) {
            if ($brunchBookCategory.length != 0 && $brunchBookCategory.val() == 0) {
                alert('브런치북 참여분야를 선택해주세요.');
                openBookCategoryLayer();
                return false;
            }
        }

        return true;
    };

    // event
    var onFormSubmit = function (e) {
        e.preventDefault();

        validateTitle(true);
        validateTagList();

        if (!validateEvent()) {
            return;
        }

        if (!_titleValidation) {
            $titleInput.focus();
            return;
        }

        if (!_originalMagazine && !_addressValidation) {
            $addressInput.focus();
            return;
        }

        if (!_tagValidation) {
            $tagInput.focus();
            return;
        }

        var address = $addressInput.val();
        var title = B.Util.trim($titleInput.val());
        var tags = _tagList.join(',');
        var allowJoin = $allowJoin.val() == '1';

        if (_originalMagazine) {
            _postMagazine(address, title, tags, allowJoin);
        } else {
            B.Util.confirm(B.Config.createMagazineConfirm, function (isOk) {
                if (isOk) {
                    _postMagazine(address, title, tags, allowJoin);
                }
            });
        }
    };

    var onFormReset = function (e) {
        e.preventDefault();
        _failHandler();
    };

    var onBodyClick = function (e) {
        var $btn = getActionButton(this, e.target);
        var action = $btn.data('action');

        if (action == 'delete-tag') {
            _removeTag($btn);
        } else if (action == 'close') {
            _failHandler();
        } else if (action == 'openBookCategory') {
            e.preventDefault();
            e.stopPropagation();
            openBookCategoryLayer();
            return;
        } else if (action == 'choiceBookCategory') {
            e.preventDefault();
            e.stopPropagation();
            choiceBookCategory($btn.data('key'));
        }

        closeBookCategoryLayer();
    };

    var choiceBookCategory = function (categoryKey) {
        if (_bookEvent && _bookEvent.bookCategory) {
            var category = _bookEvent.bookCategory[categoryKey];
            var $label = $('.opt_field_label').html(category);
            $brunchBookCategory.val(categoryKey);
        }
    };

    var openBookCategoryLayer = function () {
        var $openOptionField = $('.opt_field.opt_close');

        if ($openOptionField.length > 0 && _brunchBookChecked) {
            $openOptionField.removeClass('opt_close').addClass('opt_open');
        } else {
            closeBookCategoryLayer();
        }
    };

    var closeBookCategoryLayer = function () {
        var $openOptionField = $('.opt_field.opt_open');

        if ($openOptionField.length > 0) {
            $openOptionField.removeClass('opt_open').addClass('opt_close');
        }
    };

    var getActionButton = function (container, target) {
        var btn = $(target);
        while (!btn.is(container) && !btn.data('action')) {
            btn = btn.parent();
        }

        return btn;
    };

    var onTitleKeyup = function (e) {
        $titleBox.find('.placeholder').css('display', 'none');
        $titleInput.focus();
        validateTitle(false);
    };

    var onTitleBlur = function (e) {
        validateTitle(true);
    };

    var onTagInputKeydown = function (e) {

        var tag = B.Util.trim($tagInput.val());

        switch (e.keyCode) {
            case KEY.TAB:
                if (tag.length == 0) {
                    return;
                }
            /* falls through */
            case KEY.RETURN:
            case KEY.COMMA:
            case KEY.SPACE:
                if (!e.shiftKey && !e.altKey && !e.metaKey && !e.ctrlKey) {
                    e.preventDefault();

                    _addTag(tag);
                    return;
                }
        }
    };

    var onMagazineAddressBlur = function (e) {
        validateAddress(true);
    };

    var onMagazineAddressKeyup = function (e) {
        validateAddress(false);
    };

    var onJoinCheckClick = function (e) {
        $allowJoin.val($allowJoin.val() == '1' ? '' : '1');
        _adjustAllowJoin();
    };

    var onTitleBoxClick = function () {
        $titleBox.find('.placeholder').css('display', 'none');
        $titleInput.focus();
    };

    var onBrunchBookCheckClick = function (e) {
        $allowBrunchBook.val($allowBrunchBook.val() == '1' ? '' : '1');

        if ($allowBrunchBook.val() != '1') {
            alert('체크를 해제하시면 브런치북 프로젝트에 참여하실 수 없습니다.\n브런치북에 참여하시려면 다시 체크 박스를 클릭해 주세요! ');
        }

        _adjustAllowBrunchBook();
    };


    B.Magazine.Form = {
        init: function (options) {
            _init(options);
        },
        initForm: function (originalMagazine) {
            _initForm(originalMagazine);
        },
        show: function () {
            _show();
        },
        hide: function () {
            _hide();
        }
    };

})(jQuery);
